import { CSSProperties, HTMLAttributes, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  className?: HTMLAttributes<HTMLElement>["className"];
  id?: HTMLAttributes<HTMLElement>["id"];
  width?: CSSProperties["width"];
}>;

export default function MainHeader({ children, className, id, width }: Props) {
  const styles: CSSProperties = {
    overflow: "hidden",
    width: width || "100%",
  };

  return (
    <header className={className} id={id} style={styles}>
      {children}
    </header>
  );
}
